



































import { Component, Vue } from 'vue-property-decorator'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

Vue.use(VueMaterial)

export default class App extends Vue {
  created () {}

  home() {

  }
}
